import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { LinkWithEnglishSuperset, StyledLink, StyledRouterLink } from 'developer-docs-shared-components/components/Link';
import themes from 'developer-docs-shared-components/config/themes';
import { getDocumentationPageLink, getInAppDocLink } from '../utils/linkHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
function Link(props) {
  const {
    href,
    children
  } = props;
  const theme = useContext(ThemeContext);
  if (href.startsWith('/')) {
    const onInAppDocPage = theme && theme.themeName === themes.PORTAL_AUTHED.themeName;
    if (onInAppDocPage) {
      return getInAppDocLink({
        href,
        children
      });
    }
    if (href.startsWith('/doc')) {
      return getDocumentationPageLink({
        href,
        children
      });
    }
    return /*#__PURE__*/_jsx(StyledRouterLink, {
      to: href,
      children: children
    });
  } else if (href.startsWith('#')) {
    return /*#__PURE__*/_jsx(StyledLink, {
      href: href,
      children: children
    });
  }

  /** Link pointing to `en-us` on public UX */
  const isEnUsLink = href.match(/http(s)?:\/\/developers.hubspot.com/g);
  const sharedProps = {
    href,
    external: true,
    children
  };
  if (isEnUsLink) {
    return /*#__PURE__*/_jsx(LinkWithEnglishSuperset, Object.assign({}, sharedProps));
  }
  return /*#__PURE__*/_jsx(StyledLink, Object.assign({}, sharedProps));
}
export default Link;